const defaultApiUrl = "https://api2.marketview.club:3617";
// const defaultApiUrl = "http://localhost:3617";

const getApiUrl = () => {
	return localStorage.getItem("externalApiUrl") || null;
};

const getSocketUrl = () => {
	return localStorage.getItem("externalApiUrl") || null;
};

module.exports = {
	apiUrl: defaultApiUrl,
	getApiUrl,
	getSocketUrl,
};
